// SendGrid Email Search History Utility
// Manages persistence of email searches in localStorage
import logger from './logger';
const STORAGE_KEY = 'sendgrid_gsd_search_history';
const MAX_HISTORY_ITEMS = 10;

export const sendgridSearchHistoryUtils = {
  /**
   * Get all email search history items
   * @returns {Array} Array of email history strings
   */
  getHistory: () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      logger.error('Error reading SendGrid search history:', error);
      return [];
    }
  },

  /**
   * Add a new email to history
   * @param {string} email - The email address to add
   */
  addToHistory: (email) => {
    try {
      if (!email) return;

      const history = sendgridSearchHistoryUtils.getHistory();
      
      // Remove duplicate if exists (case-insensitive)
      const filteredHistory = history.filter(
        item => item.toLowerCase() !== email.toLowerCase()
      );

      // Add new email to beginning
      const updatedHistory = [email, ...filteredHistory];

      // Keep only last 10 items
      const trimmedHistory = updatedHistory.slice(0, MAX_HISTORY_ITEMS);

      localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmedHistory));
    } catch (error) {
      logger.error('Error saving SendGrid search history:', error);
    }
  },

  /**
   * Clear all search history
   */
  clearHistory: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      logger.error('Error clearing SendGrid search history:', error);
    }
  },

  /**
   * Remove a specific email from history
   * @param {string} email - Email to remove
   */
  removeFromHistory: (email) => {
    try {
      const history = sendgridSearchHistoryUtils.getHistory();
      const updatedHistory = history.filter(
        item => item.toLowerCase() !== email.toLowerCase()
      );
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
    } catch (error) {
      logger.error('Error removing from SendGrid search history:', error);
    }
  }
};

export default sendgridSearchHistoryUtils;
